module.exports = __webpack_public_path__ + "img/logo.dd5c2f4f.svg";